// Breakpoint thresholds match Tailwind CSS v3 defaults (sm=640, lg=1024).
export type Device = 'phone' | 'tablet' | 'desktop';

export interface Breakpoint {
  device: Device;
  width: number;
}

export function classify_width(width: number): Device {
  if (width < 640) return 'phone';
  if (width <= 1024) return 'tablet';
  return 'desktop';
}
